module.exports = __webpack_public_path__ + "static/media/0_2019_05_18.a530e62a.jpg";